import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["username", "password", "link"];

  toggle(event) {
    event.preventDefault();

    const isDisabled = this.usernameTarget.disabled;

    this.usernameTarget.disabled = !isDisabled;
    this.passwordTarget.disabled = !isDisabled;
    this.usernameTarget.required = isDisabled;
    this.passwordTarget.required = isDisabled;

    this.linkTarget.textContent = isDisabled ? window.I18n["views.admin.workflow_agents.disable_authentication"] : window.I18n["views.admin.workflow_agents.update_authentication"];
  }
}